/**
 * Community Cookie Management
 * Handles storing and retrieving the user's last selected community
 */

const COMMUNITY_COOKIE_NAME = 'talktrail_selected_community';
const COOKIE_EXPIRY_DAYS = 30;

/**
 * Set the selected community cookie
 * @param {string} communitySlug - The slug of the community
 * @param {string} communityOid - The OID of the community
 */
export function setSelectedCommunity(communitySlug, communityOid) {
  const communityData = JSON.stringify({
    slug: communitySlug,
    oid: communityOid,
  });
  const expiryDate = new Date();
  expiryDate.setDate(expiryDate.getDate() + COOKIE_EXPIRY_DAYS);

  document.cookie = `${COMMUNITY_COOKIE_NAME}=${encodeURIComponent(
    communityData
  )}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
}

/**
 * Get the selected community from cookie
 * @returns {Object|null} - { slug: string, oid: string } or null if not set
 */
export function getSelectedCommunity() {
  const cookies = document.cookie.split(';');

  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === COMMUNITY_COOKIE_NAME) {
      try {
        return JSON.parse(decodeURIComponent(value));
      } catch (e) {
        console.error('Failed to parse community cookie:', e);
        return null;
      }
    }
  }

  return null;
}

/**
 * Clear the selected community cookie
 */
export function clearSelectedCommunity() {
  document.cookie = `${COMMUNITY_COOKIE_NAME}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

/**
 * Check if user has a selected community
 * @returns {boolean}
 */
export function hasSelectedCommunity() {
  return getSelectedCommunity() !== null;
}
